module.exports = __webpack_public_path__ + "img/gold4.f07cc022.png";